export const equipmentOptions = [
  {
    label: 'Poussette',
    en_label: 'Stroller',
    option: 'poussette',
    key: 'poussette',
  },
  {
    label: 'Siège auto',
    en_label: 'Car seat',
    option: 'siege-auto',
    key: 'siege-auto',
  },
  {
    label: 'Lit parapluie',
    en_label: 'Travel crib',
    option: 'lit-parapluie',
    key: 'lit-parapluie',
  },
  {
    label: 'Chaise haute',
    en_label: 'High chair',
    option: 'chaise-haute',
    key: 'chaise-haute',
  },
  {
    label: 'Jeux, livres',
    en_label: 'Games, books',
    option: 'jeux-livres',
    key: 'jeux-livres',
  },
  {
    label: 'Bain',
    en_label: 'Bath',
    option: 'bain',
    key: 'bain',
  },
  {
    label: 'Activités extérieures',
    en_label: 'Outdoor activities',
    option: 'activites-exterieures',
    key: 'activites-exterieures',
  },
];

export const extraConfigOptions = [
  {
    name: `Type d'équipement`,
    en_name: 'Equipment type',
  },
  {
    name: `Informations supplémentaires`,
    en_name: 'Additional information',
  },
  {
    name: `Devenir loueur`,
    en_name: 'Become a Lessor',
  },
];
